import { render, staticRenderFns } from "./Content_letters.vue?vue&type=template&id=4c99749e&scoped=true"
import script from "./Content_letters.vue?vue&type=script&lang=js"
export * from "./Content_letters.vue?vue&type=script&lang=js"
import style0 from "./Content_letters.vue?vue&type=style&index=0&id=4c99749e&prod&lang=css"
import style1 from "./Content_letters.vue?vue&type=style&index=1&id=4c99749e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99749e",
  null
  
)

export default component.exports